
import Main from '../../layouts/Main';
import Container from '../../components/Container';
import {Box} from '@mui/material';
import PageBreadcrumbs from '../../components/PageBreadcrumbs';
import MunicipalMap from '../Home1/components/MunicipalMap';

const Map = (): JSX.Element => {

  document.title = 'OCPF - Municipal Map';

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Box marginBottom={2}></Box>
        <MunicipalMap></MunicipalMap>
      </Container>
    </Main>
  );
};

export default Map;